import script from "./ClapScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClapScreen.vue?vue&type=script&setup=true&lang=ts"

import "./ClapScreen.vue?vue&type=style&index=0&id=6f61d35c&scoped=true&lang=scss"

import exportComponent from "/app/fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f61d35c"]])

export default __exports__